module.exports = __webpack_public_path__ + "static/media/cartao-de-credito.fdbcb48a.png";